/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ConfigSetting } from '../models/config-setting';
import { configSettingCreateConfig } from '../fn/config-setting/config-setting-create-config';
import { ConfigSettingCreateConfig$Params } from '../fn/config-setting/config-setting-create-config';
import { configSettingDelete } from '../fn/config-setting/config-setting-delete';
import { ConfigSettingDelete$Params } from '../fn/config-setting/config-setting-delete';
import { configSettingGetCarefinityTransaction } from '../fn/config-setting/config-setting-get-carefinity-transaction';
import { ConfigSettingGetCarefinityTransaction$Params } from '../fn/config-setting/config-setting-get-carefinity-transaction';
import { configSettingGetConfig } from '../fn/config-setting/config-setting-get-config';
import { ConfigSettingGetConfig$Params } from '../fn/config-setting/config-setting-get-config';
import { configSettingGetPracticeSettings } from '../fn/config-setting/config-setting-get-practice-settings';
import { ConfigSettingGetPracticeSettings$Params } from '../fn/config-setting/config-setting-get-practice-settings';
import { configSettingGetPracticeSettingsFromXmlFile } from '../fn/config-setting/config-setting-get-practice-settings-from-xml-file';
import { ConfigSettingGetPracticeSettingsFromXmlFile$Params } from '../fn/config-setting/config-setting-get-practice-settings-from-xml-file';
import { configSettingPut } from '../fn/config-setting/config-setting-put';
import { ConfigSettingPut$Params } from '../fn/config-setting/config-setting-put';
import { configSettingPut2 } from '../fn/config-setting/config-setting-put-2';
import { ConfigSettingPut2$Params } from '../fn/config-setting/config-setting-put-2';
import { configSettingSavePracticeSettings } from '../fn/config-setting/config-setting-save-practice-settings';
import { ConfigSettingSavePracticeSettings$Params } from '../fn/config-setting/config-setting-save-practice-settings';
import { configSettingUpdatepracticeSetting } from '../fn/config-setting/config-setting-updatepractice-setting';
import { ConfigSettingUpdatepracticeSetting$Params } from '../fn/config-setting/config-setting-updatepractice-setting';
import { JsonSettings } from '../models/json-settings';
import { PracticeSettings } from '../models/practice-settings';

@Injectable({ providedIn: 'root' })
export class ConfigSettingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `configSettingGetConfig()` */
  static readonly ConfigSettingGetConfigPath = '/api/ConfigSetting';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `configSettingGetConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  configSettingGetConfig$Response(params?: ConfigSettingGetConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<JsonSettings>> {
    return configSettingGetConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `configSettingGetConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  configSettingGetConfig(params?: ConfigSettingGetConfig$Params, context?: HttpContext): Observable<JsonSettings> {
    return this.configSettingGetConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<JsonSettings>): JsonSettings => r.body)
    );
  }

  /** Path part for operation `configSettingCreateConfig()` */
  static readonly ConfigSettingCreateConfigPath = '/configsetting/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `configSettingCreateConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  configSettingCreateConfig$Response(params: ConfigSettingCreateConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return configSettingCreateConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `configSettingCreateConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  configSettingCreateConfig(params: ConfigSettingCreateConfig$Params, context?: HttpContext): Observable<Blob> {
    return this.configSettingCreateConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `configSettingPut()` */
  static readonly ConfigSettingPutPath = '/configSetting/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `configSettingPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  configSettingPut$Response(params: ConfigSettingPut$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return configSettingPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `configSettingPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  configSettingPut(params: ConfigSettingPut$Params, context?: HttpContext): Observable<Blob> {
    return this.configSettingPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `configSettingPut2()` */
  static readonly ConfigSettingPut2Path = '/api/ConfigSetting/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `configSettingPut2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  configSettingPut2$Response(params: ConfigSettingPut2$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return configSettingPut2(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `configSettingPut2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  configSettingPut2(params: ConfigSettingPut2$Params, context?: HttpContext): Observable<Blob> {
    return this.configSettingPut2$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `configSettingDelete()` */
  static readonly ConfigSettingDeletePath = '/api/ConfigSetting/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `configSettingDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  configSettingDelete$Response(params: ConfigSettingDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return configSettingDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `configSettingDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  configSettingDelete(params: ConfigSettingDelete$Params, context?: HttpContext): Observable<Blob> {
    return this.configSettingDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `configSettingGetCarefinityTransaction()` */
  static readonly ConfigSettingGetCarefinityTransactionPath = '/configsetting/getconfigsetting';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `configSettingGetCarefinityTransaction()` instead.
   *
   * This method doesn't expect any request body.
   */
  configSettingGetCarefinityTransaction$Response(params?: ConfigSettingGetCarefinityTransaction$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigSetting>> {
    return configSettingGetCarefinityTransaction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `configSettingGetCarefinityTransaction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  configSettingGetCarefinityTransaction(params?: ConfigSettingGetCarefinityTransaction$Params, context?: HttpContext): Observable<ConfigSetting> {
    return this.configSettingGetCarefinityTransaction$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConfigSetting>): ConfigSetting => r.body)
    );
  }

  /** Path part for operation `configSettingSavePracticeSettings()` */
  static readonly ConfigSettingSavePracticeSettingsPath = '/configsetting/save';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `configSettingSavePracticeSettings()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  configSettingSavePracticeSettings$Response(params: ConfigSettingSavePracticeSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return configSettingSavePracticeSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `configSettingSavePracticeSettings$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  configSettingSavePracticeSettings(params: ConfigSettingSavePracticeSettings$Params, context?: HttpContext): Observable<Blob> {
    return this.configSettingSavePracticeSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `configSettingGetPracticeSettings()` */
  static readonly ConfigSettingGetPracticeSettingsPath = '/configsetting/getpracticesetting';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `configSettingGetPracticeSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  configSettingGetPracticeSettings$Response(params?: ConfigSettingGetPracticeSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<PracticeSettings>> {
    return configSettingGetPracticeSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `configSettingGetPracticeSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  configSettingGetPracticeSettings(params?: ConfigSettingGetPracticeSettings$Params, context?: HttpContext): Observable<PracticeSettings> {
    return this.configSettingGetPracticeSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<PracticeSettings>): PracticeSettings => r.body)
    );
  }

  /** Path part for operation `configSettingUpdatepracticeSetting()` */
  static readonly ConfigSettingUpdatepracticeSettingPath = '/configSetting/updatepracticeSetting';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `configSettingUpdatepracticeSetting()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  configSettingUpdatepracticeSetting$Response(params: ConfigSettingUpdatepracticeSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return configSettingUpdatepracticeSetting(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `configSettingUpdatepracticeSetting$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  configSettingUpdatepracticeSetting(params: ConfigSettingUpdatepracticeSetting$Params, context?: HttpContext): Observable<Blob> {
    return this.configSettingUpdatepracticeSetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `configSettingGetPracticeSettingsFromXmlFile()` */
  static readonly ConfigSettingGetPracticeSettingsFromXmlFilePath = '/configsetting/getpracticesettingfromxmlfile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `configSettingGetPracticeSettingsFromXmlFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  configSettingGetPracticeSettingsFromXmlFile$Response(params?: ConfigSettingGetPracticeSettingsFromXmlFile$Params, context?: HttpContext): Observable<StrictHttpResponse<PracticeSettings>> {
    return configSettingGetPracticeSettingsFromXmlFile(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `configSettingGetPracticeSettingsFromXmlFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  configSettingGetPracticeSettingsFromXmlFile(params?: ConfigSettingGetPracticeSettingsFromXmlFile$Params, context?: HttpContext): Observable<PracticeSettings> {
    return this.configSettingGetPracticeSettingsFromXmlFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<PracticeSettings>): PracticeSettings => r.body)
    );
  }

}
